import { useAuth } from "../use-auth";

// const configs = require('../configs/constant.json');

export function ThankPaymentPage(props) {
  const context = useAuth();
  const configs = context.config;
  const user = context.user || null;

  return (
    <div className="container">
      <div className="row">
      <div className="col-lg-5 d-none d-lg-block bg-register-image my-1" style={{minHeight: '500px'}}></div>
      <div className="col-lg-5 offset-lg-2">
        <h2 className="text-black">ขอบคุณสำหรับการชำระเงิน</h2>
        <p>CRK Store ขอบคุณสำหรับลูกค้าที่ให้ความไว้วางใจทำการชำระเงิน 
          เพื่อใช้บริการโปรแกรมคุณภาพที่ผ่านการคัดสรรจาก CRK Solution<br />
          ทางบริษัทจะรีบดำเนินการให้โดยเร็ว</p>
        <br />
        <p>หากต้องการสอบถามข้อมูลเพิ่มเติม &nbsp;
          <a href={configs.URL_CONTACT_US}>คลิก</a>
        </p>
        <br />
        {window.opener && <button className="btn btn-info" onClick={() => window.close()}>ปิด</button>}
        {!window.opener && <a className='btn btn-info' href={user ? '/member/home' : '/'}>ไปหน้าหลัก</a>}
      </div>
      </div>
    </div>
  )
}
